import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Theme from "../../vars/ThemeOptions";

const Styled = {};
Styled.P = styled.div`
  max-width: 40vw;
  margin: 0 auto;
  text-align: center;
  .embedded-image-wrap {
    overflow: hidden;
    position: relative;
    margin: auto;
    .embedded-image {
      object-fit: cover;
      max-widtH: 100%;
    }
    .embedded-image-description {
      font-size: .8rem;
      text-align: center;
      padding: .25rem;
    }
  }
  &.white {
    color: ${Theme.hex("white")};
  }
  &.fluid {
    max-width: 80vw;
    padding: 0 8vw;
  }
  &.left {
    text-align: left;
  }
  a {
    color: ${Theme.hex("green")};
  }
  ul > li > * {
    text-align: left;
  }
  code {
    vertical-align: super;
    font-size: 70%;
    font-family: "Nunito Sans", sans-serif;
    color: ${Theme.hex("black")};
  }
  @media screen and (max-width: ${Theme.break.sm}px) {
    max-width: 90vw;
    &.fluid {
      max-width: 95vw;
    }
  }
  p b {
    font-weight: 700;
  }
  .body-copy-quote {
    position: relative;
    margin-bottom: 8vh;
    :after {
      content: "";
      position: absolute;
      bottom: -8vh;
      left: 50%;
      width: 1px;
      height: 8vh;
      background-color: #ccc;
    }
    .timeline-group {
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
      padding: 1vh 1rem;
      text-align: center;
      strong {
        display: block;
        width: 100%;
        font-weight: 700;
        text-align: center;
        font-size: 2rem;
      }
    }
  }
`;
export const P = React.forwardRef(
  ({ children, white, className, fluid, left }, ref) => {
    const _classname = white ? ["white"] : ["black"];
    _classname.push("thr-p");
    _classname.push(className);
    if (fluid) _classname.push("fluid");
    if (left) _classname.push("left");
    return (
      <Styled.P className={_classname.join(" ")} ref={ref}>
        {children}
      </Styled.P>
    );
  }
);

P.defaultProps = {
  white: false,
  fluid: false,
  left: false,
  className: "",
};

P.propTypes = {
  children: PropTypes.node.isRequired,
  white: PropTypes.bool,
  fluid: PropTypes.bool,
  left: PropTypes.bool,
  className: PropTypes.string,
};
